import { A9Service, AbstractDataProviderV2, IResourceParams, ICollectionParams } from 'components/system';

import type { CustomerBusinessAdd } from 'common/customers/services/types/CustomerBusinessAdd';
import type { RsBusinessStaffAdd } from 'common/customers/services/types/RsBusinessStaffAdd';
import type { RsCustomerInfo } from 'common/customers/services/types/RsCustomerInfo';
import type { RsCustomerBusiness } from 'common/customers/services/types/RsCustomerBusiness';
import type { RsAsyncTaskPerformResult } from 'common/sys-tasks/services/types/RsAsyncTaskPerformResult';

@A9Service('customerBusinessDataProvider')
export class CustomerBusinessDataProvider extends AbstractDataProviderV2<RsCustomerBusiness, RsCustomerBusiness, CustomerBusinessAdd, null> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/business');
    }

    public patch(): Promise<never> {
        return Promise.reject('Method is not supported');
    }

    public remove(): Promise<never> {
        return Promise.reject('Method is not supported');
    }

    public getStaffMemberBusinessList(staffMemberId: number): Promise<any> {
        return this.service.getItem<RsCustomerInfo['businesses']>(`${this.url}/${staffMemberId}/businesses`);
    }

    public updateGeneralDetails(businessId: string, data: any): Promise<never> {
        return this.service.updateRequest<never>(`${this.url}/${businessId}/general`, 'PUT', data);
    }

    public getPageNames(
        collectionParams: ICollectionParams = {},
        resourceParams: IResourceParams = {},
        light: boolean = true,
        timeout?: Promise<void>
    ) {
        const url = this.helper.buildUrl(this.apiUrl + '/page-names', resourceParams);
        let firstPage = 0,
            lastPage = 0;
        if (collectionParams.filters) {
            firstPage = collectionParams.filters.firstPage || 0;
            lastPage = collectionParams.filters.lastPage || 0;
            collectionParams.filters.firstPage = firstPage > 0 ? firstPage : 0;
            collectionParams.filters.lastPage = lastPage > 0 ? lastPage : 0;
        }
        return this.service
            .getList<any>(url, this.buildListingRequestParams(collectionParams), timeout)
            .then(list => {
                const result = {};
                if (list.items && list.items.length) {
                    list.items.forEach((item, i) => {
                        result[String(i + firstPage)] = light ? item.name : item;
                    });
                }
                return result;
            })
            .catch(error => {
                throw this.service.handleError(error, { url: url, method: 'GET', params: collectionParams });
            });
    }
}
